import { render, staticRenderFns } from "./RoomBillDetail.vue?vue&type=template&id=6a3a4b4a"
import script from "./RoomBillDetail.vue?vue&type=script&lang=js"
export * from "./RoomBillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports